import CardLogin from 'components/CardLogin'
import FormLogin from 'components/FormLogin'
import { routes } from 'core/const/routes'
import { useRouter } from 'next/router'
import useAuth from 'hooks/useAuth'
import { useState } from 'react'
import * as S from './styles'

import { Col, Row } from 'react-bootstrap'
import HeaderLogin from 'components/HeaderLogin'
import MediaMatch from 'components/ui/MediaMatch'
import Image from 'next/image'
import LogoArquiteto from '../../../public/img/logo-login.png'
import AnimaBalde from 'components/ui/AnimaBalde'
const Auth = () => {
  const [modalUrl, setModalUrl] = useState(false)
  const { usuario, signOut, logado } = useAuth()
  const router = useRouter()

  return (
    <S.Wrapper>
      <HeaderLogin />
      <div className="container-fluid">
        <S.BoxContent>
          <Row>
            <Col lg={6} className="p-0">
              <MediaMatch lessThan="small">
                <div className="d-flex justify-content-center w-100">
                  <Image
                    width={68}
                    height={68}
                    src={LogoArquiteto}
                    objectFit="fill"
                    alt="Logo Arquiteto bolso"
                    className="imageLogo"
                  />
                </div>
              </MediaMatch>
              <S.BoxTitle>
                <S.Box>
                  <S.Title>
                    Do tamanho do seu <span>orçamento</span>.
                  </S.Title>
                  <S.Title>
                    Gigante nas <span className="primary">soluções</span>.
                  </S.Title>
                </S.Box>
                <S.BoxTinta>
                  <MediaMatch greaterThan="small">
                    <>
                      <AnimaBalde />
                      <S.BoxImage>
                        <img src="img/casal-login.png" alt="" />
                      </S.BoxImage>
                    </>
                  </MediaMatch>
                  <MediaMatch lessThan="small">
                    <>
                      <S.BoxImage>
                        <img src="img/casal-mobile.png" alt="" />
                      </S.BoxImage>
                    </>
                  </MediaMatch>
                </S.BoxTinta>
              </S.BoxTitle>
            </Col>
            <Col lg={6} className="p-0">
              <S.BoxLogin>
                <CardLogin>
                  <FormLogin setModalUrl={setModalUrl} />
                </CardLogin>
              </S.BoxLogin>
            </Col>
          </Row>
        </S.BoxContent>
      </div>
    </S.Wrapper>
  )
}

export default Auth
